

    <div class="app-version">
      {{version}}
    </div>
  